namespace TabAurous.Inventory {
    export interface MaterialPaymentForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        PartyId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        Country: Serenity.StringEditor;
        State: Serenity.StringEditor;
        TermsId: Serenity.IntegerEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.IntegerEditor;
        ItemDetails: MaterialReceiptItemsEditor;
        Remark: Serenity.TextAreaEditor;
        RoundOff: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BillAddId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class MaterialPaymentForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.MaterialPayment';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MaterialPaymentForm.init)  {
                MaterialPaymentForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.LookupEditor;
                var w6 = s.TextAreaEditor;
                var w7 = s.DecimalEditor;
                var w8 = MaterialReceiptItemsEditor;

                Q.initFormType(MaterialPaymentForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'AutoPosting', w4,
                    'PartyId', w5,
                    'LedgerName', w2,
                    'Address1', w6,
                    'Country', w2,
                    'State', w2,
                    'TermsId', w3,
                    'CurrencyId', w5,
                    'ExchRate', w7,
                    'EmployeeId', w3,
                    'ItemDetails', w8,
                    'Remark', w6,
                    'RoundOff', w3,
                    'CompanyId', w3,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'BillAddId', w3,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'UserId', w3,
                    'FinancialYearId', w3
                ]);
            }
        }
    }
}
